<template>
    <div class="barjestegi-container">
        <!-- Header -->
        <div 
            class="header"
            :style="{ 'background-image': brgPic ? 'url(' + URL + '/' + brgPic + ')' : 'linear-gradient(180deg, #00f6ff -50%, transparent)' }"
        >
            <!-- 
                <div class="header-desc">
                    <span class="regular">مهارت کسب کن و تو حوزه خودت</span>
                    <span class="big blue">بـرجـسـتـه&nbsp;</span>
                    <span class="big">شو&nbsp;</span>
                    <span class="big yellow">...</span>
                </div>

                <img class="header-pointer" :src="Pointer" alt="Pointer">
                <img class="header-chart" :src="Chart" alt="Chart">
                
                <img class="header-red" :src="RedShape" alt="RedShape">
                <img class="header-yellow" :src="YellowShape" alt="YellowShape"> 
            
                <img class="header-char" :src="Character" alt="Character"> 
            -->
        </div>

        <!-- Content -->
        <div class="content-container">
            <div class="content-text">
                <router-link 
                tag="button" :to="{ name: 'MyCourses' }"
                class="btn btn-light btn-register"
                >دوره‌های من</router-link>

                <span style="margin: auto auto auto 0;">{{ brgTitle }}</span>
            </div>

            <div class="result-container">
                <!-- Top Slides -->
                <div class="top-slides" :class="{ 'blue-banner': discount == false}">
                    <div class="container">
                        <div class="row">
                            <!-- DEST -->
                            <div class="slides-desc">
                                <img 
                                    :class="{ 'not-active': discount == false}"
                                    class="discount" :src="URL + '/' + brgIcon" alt="Discount"
                                >
                                <span>{{ brgBTSmall }}</span>
                                <span class="big-span">{{ brgBTLarge }}</span>
                                <img v-if="duration" class="timer" :src="Timer" alt="Timer">
                                <span v-if="duration">مانده تا پایان تخفیف</span>
                                <div
                                    :key="durationKey" 
                                    v-if="duration"
                                    class="time-counter"
                                >
                                    <div>
                                        <span>{{ duration.years() * 365 * 24 + duration.months() * 30 * 24 + duration.days() * 24 + duration.hours() }}</span>
                                        <span>ساعت</span>
                                    </div>
                                    <div>
                                        <span>{{ duration.minutes() }}</span>
                                        <span>دقیقه</span>
                                    </div>
                                    <div>
                                        <span>{{ duration.seconds() }}</span>
                                        <span>ثانیه</span>
                                    </div>
                                </div>
                            </div>
                            <!-- CAROUSEL -->
                            <div class="slides-carousel">
                                <carousel 
                                    :perPageCustom="[[0, 1]]" 
                                    :spacePadding="15"
                                    :paginationEnabled="false"
                                >
                                    <slide 
                                        class="slide-item"
                                        v-for="(dc, index) in discountCourses"
                                        :key="index"
                                    >
                                        <router-link
                                            :to="{ name: 'CourseDetails', params: { id: dc._id } }"
                                            class="inner-item" tag="div"
                                            :class="{ 'not-active': dc.Discount <= 0 }"
                                            :style="{ 'background-image':
                                                dc.dCover && dc.Discount ? ('url(' + URL + '/' + dc.dCover + ')') : 'linear-gradient(0deg, #592aba 25%, #e55065)'
                                            }"
                                        >
                                           
                                        </router-link>
                                    </slide>
                                </carousel>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Item List -->
                <div class="list-container">
                    <div class="item-list">
                        <span
                            @click="() => { this.sType = 'find-new-all' }" 
                            :class="{'active': sType == 'find-new-all' }">همه</span>
                        <span
                            @click="() => { this.sType = 'find-latests' }" 
                            :class="{'active': sType == 'find-latests'}">جدیدترین‌ها</span>
                        <span
                            @click="() => { this.sType = 'find-discount' }" 
                            :class="{'active': sType == 'find-discount'}">تخفیفی‌ها</span>
                        <span
                            @click="() => { this.sType = 'find-favorites' }" 
                            :class="{'active': sType == 'find-favorites'}">محبوب‌ترین‌ها</span>
                    </div>
                </div>

                <!-- Result -->
                <div class="result">
                    <div 
                        class="result-item"
                        :key="index"
                        v-for="(crs, index) in courses"
                    >
                        <router-link 
                            class="top-item"
                            tag="div" :to="{ name: 'CourseDetails', params: { id: crs._id } }" 
                        >
                            <div 
                                class="circle"
                            >
                                <!-- <i class="fas fa-car-crash"></i> -->
                                <img :src="URL + '/' + crs.Icon" alt="icon">
                            </div>
                            <span class="title">{{ crs.Title }}</span>
                            <span class="text">{{ crs.Desc }}</span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Chart from '@/assets/images/barjestegi/chart.png';
import Pointer from '@/assets/images/barjestegi/pointer.png';
import RedShape from '@/assets/images/barjestegi/red_shape.png';
import YellowShape from '@/assets/images/barjestegi/yellow_shape.png';
import Character from '@/assets/images/barjestegi/character.png';

import Timer from '@/assets/images/barjestegi/timer.png';
import Discount from '@/assets/images/barjestegi/discount.png';

import CardBack from '@/assets/images/barjestegi/card_back.png';
import PercentShock from '@/assets/images/barjestegi/percent_shock.png';

import Heart from '@/assets/images/barjestegi/heart.png';
import Percent from '@/assets/images/barjestegi/percent.png';
import Bell from '@/assets/images/barjestegi/bell.png';
import Search from '@/assets/images/barjestegi/search.png';

import { Carousel, Slide } from 'vue-carousel';

import { getRequest, APP_API_URL } from '@/utils/libs/api-request';
// import Cookies from 'js-cookie';

import moment from 'moment';

export default {
    name: 'Barjestegi',
    data() {
        return {
            handle: undefined,
            sType: 'find-new-all',
            courses: {},
            discountCourses: {},
            discount: false,
            duration: undefined,
            durationKey: 1,
            URL: APP_API_URL(),

            brgPic: undefined,
            brgIcon: undefined,
            brgTitle: undefined,
            brgBTSmall: undefined,
            brgBTLarge: undefined,

            Chart: Chart,
            Pointer: Pointer,
            RedShape: RedShape,
            YellowShape: YellowShape,
            Character: Character,

            Timer: Timer,
            Discount: Discount,

            Heart: Heart,
            Percent: Percent,
            Bell: Bell,
            Search: Search,

            CardBack: CardBack,
            PercentShock: PercentShock
        }
    },
    mounted() {
        this.getCurrent();
        this.getData();
    },
    watch: {
        sType() {
            this.getCurrent()
        }
    },
    methods: {
        getData() {
            getRequest('/cms/find-top')
                .then((rsp) => {
                    let data = rsp['data'][0]

                    if(data) {
                        this.brgPic = data.BrgPic;
                        this.brgIcon = data.BrgIcon;
                        this.brgTitle = data.BrgTitle;
                        this.brgBTSmall = data.BrgBTSmall;
                        this.brgBTLarge = data.BrgBTLarge;
                    }
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        // if (err.response.status == 401) {
                        //     Cookies.remove('access_cookie');
                        //     this.$router.push({ name: 'Login' })
                        // }
                    }
                });
        },
        getCurrent() {
            getRequest('/base-courses/' + this.sType)
                .then((rsp) => {
                    this.courses = rsp['data'];
                    this.discountCourses = rsp['data'];

                    let now = moment();
                    let interval = 1000; 
                    let diffTime = 0;

                    this.discountCourses.forEach(currentCourse => {
                        currentCourse.discount = false;
                        let expireDate = moment(currentCourse.ExpireDate, 'YYYY/MM/DD HH:mm');

                        if (now.isSameOrBefore(expireDate)) {
                            this.discount = true;
                            currentCourse.discount = true;

                            // Find MIN ExpireDate
                            let dT = expireDate.diff(now, 'milliseconds') ;
                            if(!diffTime) diffTime = dT;
                            else if (diffTime > dT) diffTime = dT;
                        }
                        else currentCourse.discount = false;

                        if(currentCourse.Discount == 0) currentCourse.discount = false;
                    });

                    if(this.discount) {
                        let duration = moment.duration(diffTime, 'milliseconds');
                        this.duration = moment.duration(duration);

                        if(this.handle) {
                            clearInterval(this.handle);
                        }

                        this.handle = setInterval(function(){
                            duration = moment.duration(duration - interval, 'milliseconds');
                            this.duration = moment.duration(duration);

                            this.durationKey++;
                        }.bind(this), interval);
                    }
                })
                .catch(err => {
                // check auth
                    if (err.response) {
                        // if (err.response.status == 401) {
                        //     Cookies.remove('access_cookie');
                        //     this.$router.push({ name: 'Login' })
                        // }
                    }
                });
        },
    },
    components: {
        Carousel,
        Slide
    }
}
</script>

<style scoped>
/* ---------------------------------------- */
/* ---------------- HEADER ---------------- */
/* ---------------------------------------- */
.barjestegi-container .header {
    height: 115vw;
    width: 100vw;

    position: sticky;
    top: 0;

    overflow: hidden;

    background-color: #412086;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
/* top right text */
.barjestegi-container .header-desc {
    color: #fff;
    font-weight: bold;
    padding: 15pt 20pt;
}
.barjestegi-container .header-desc .regular {
    display: block;
    font-size: 0.9rem;
}
.barjestegi-container .header-desc .big {
    font-size: 1.4rem;
}
.barjestegi-container .header-desc .blue {
    color: #00f6ff;
}
.barjestegi-container .header-desc .yellow {
    color: #fece02;
}
@media (max-width: 576px) {
    .barjestegi-container .header-desc {
        padding: 7pt 15pt;
    }
    .barjestegi-container .header-desc .regular {
        font-size: 0.7rem;
    }
    .barjestegi-container .header-desc .big {
        font-size: 1.2rem;
    }
}
/* images */
.barjestegi-container .header .header-pointer {
    height: 65vh;
    width: 65vh;

    position: absolute;

    left: -34vh;
    top: 10vh;
}
.barjestegi-container .header .header-chart{
    height: 40vh;
    width: 32vh;

    position: absolute;
    
    left: -10.5vh;
    bottom: 5vh;
}
.barjestegi-container .header .header-red {
    height: 5vh;
    width: 5vh;

    position: absolute;
    
    left: -2vh;
    bottom: 40vh;
}
.barjestegi-container .header .header-yellow {
    height: 5vh;
    width: 5vh;

    position: absolute;
    
    left: 10vh;
    bottom: 45vh;
}
.barjestegi-container .header .header-char {
    height: 75vh;

    position: absolute;

    right: 0;
    bottom: 0;
}

/* ---------------------------------------- */
/* --------------- CONTENT ---------------- */
/* ---------------------------------------- */
.barjestegi-container .content-container {
    margin-top: -9vh;
    position: relative;
    border-radius: 9vh;
    background-color: #fff;
}
.barjestegi-container .content-container .content-text {
    min-height: 9vh;
    margin-bottom: 0;
    padding: 10pt 9vh;

    display: flex;
    flex-direction: row;
}
.barjestegi-container .content-container .content-text span {
    display: inline-block;
    margin: auto 0 auto auto;
}
.barjestegi-container .content-container .content-text .btn-register {
    color: #fff;
    background-color: #252c71;
    border-color: #fff;
    border-radius: 50%;
    font-size: 8px;
    box-shadow: 1px 2px 8px #6b4764af;

    margin: auto 0 auto auto;

    height: 40pt;
    width: 40pt;
    padding: 0;
}
.barjestegi-container .content-container .result-container {
    position: relative;
    border-radius: 5vh;
    border-top-left-radius: 0;
    background-color: #ebecf1;

    padding: 20pt 0 6vh 0;
}
@media (max-width: 576px) {
    .barjestegi-container .content-container .content-text {
        font-size: 0.8rem;
    }
    .barjestegi-container .content-container .content-text {
        padding: 10pt 5vh;
    }
    .barjestegi-container .content-container .content-text span {
        padding-left: 10pt;
    }
}
/* ---------------------------------------- */
/* -------------- TOP SLIDES -------------- */
/* ---------------------------------------- */
.barjestegi-container .content-container .result-container .top-slides {
    width: calc(100% - 10pt);

    margin-right: 10pt;
    padding: 20pt 0;

    overflow: hidden;

    border: 2px solid #ffffffe8;
    border-top-right-radius: 5vh;
    border-bottom-right-radius: 5vh;

    background-color: #ffce02;
}
.barjestegi-container .content-container .top-slides .container {
    max-width: none;
}
/* slides description */
.barjestegi-container .result-container .top-slides .slides-desc {
    max-width: 148pt;
    margin-right: 15pt;
    padding: 0 5pt;

    display: flex;
    flex-direction: column;

    text-align: center;
    color: #967900;
    font-weight: bold;
}
.barjestegi-container .result-container .top-slides .slides-desc span {
    font-size: 1rem;
    display: inline-block;
    margin-top: 5pt;
}
.barjestegi-container .result-container .top-slides .slides-desc .big-span {
    margin-top: 7pt;
    margin-bottom: 10pt;

    font-size: 1.6rem;
    color: #fff;
    text-shadow: 2px 3.5px 5px #f96d0d;
}
.barjestegi-container .result-container .top-slides .slides-desc .timer {
    width: 11vh;
    max-width: 148pt;
    margin: auto;
}
.barjestegi-container .result-container .top-slides .slides-desc .discount {
    width: 16vh;
    max-width: 148pt;
    margin: auto;
}
.barjestegi-container .result-container .top-slides .slides-desc .time-counter {
    width: 100%;
    margin: auto;
    display: flex;
    flex-direction: row;
}
.barjestegi-container .result-container .top-slides .slides-desc .time-counter div {
    width: calc(33.33% - 2pt);
    margin: 15pt 2pt 0pt;
    padding: 7pt 0;

    display: flex;
    flex-direction: column;

    background-color: #f1c200;
    border-radius: 12pt;
    box-shadow: inset 1.5px 2.6px 3px 0px #cea600;
}
.barjestegi-container .result-container .top-slides .slides-desc .time-counter span {
    font-size: 1rem;
    margin: 0 auto;
}
@media (max-width: 576px) {
    .barjestegi-container .result-container .top-slides .slides-desc {
        max-width: 125pt;
        margin-right: 5pt;
    }
    .barjestegi-container .result-container .top-slides .slides-desc span {
        font-size: .8rem;
        margin-top: 5pt;
    }
    .barjestegi-container .result-container .top-slides .slides-desc .big-span {
        margin-bottom: 5pt;
        font-size: 1.2rem;
    }
    .barjestegi-container .result-container .top-slides .slides-desc .timer {
        width: 10vh;
        max-width: 125pt;
    }
    .barjestegi-container .result-container .top-slides .slides-desc .discount {
        width: 15vh;
        max-width: 125pt;
    }

    .barjestegi-container .result-container .top-slides .slides-desc .time-counter div {
        margin: 10pt 2pt 0pt;
        padding: 5pt 0;
    }
    .barjestegi-container .result-container .top-slides .slides-desc .time-counter span {
        font-size: .9rem;
    }
}
/* carousel */
.barjestegi-container .result-container .top-slides .slides-carousel {
    width: calc(100% - 164pt);

    direction: ltr;
}
.barjestegi-container .result-container .top-slides .slide-item {
    width: 100%;
    padding: 0 5pt 0 0;

    display: flex;
}
.barjestegi-container .result-container .not-active {
    filter: grayscale(1);
}
.barjestegi-container .result-container .blue-banner {
    background-color: #00f6ff !important;
}
.barjestegi-container .result-container .top-slides .inner-item {
    height: 100%;
    width: 100%;
    min-height: 215px;
    margin: auto;

    position: relative;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    border-radius: 10pt;
    color: #fff;
    font-weight: bold;
}
.barjestegi-container .result-container .top-slides >>> .VueCarousel,
.barjestegi-container .result-container .top-slides >>> .VueCarousel-wrapper,
.barjestegi-container .result-container .top-slides >>> .VueCarousel-inner {
    height: 100% !important;
}
/* slide -> text container */
.barjestegi-container .result-container .top-slides .inner-item .text-container {
    position: absolute;
    top: 37.5vh;
    right: 15pt;
}
.barjestegi-container .result-container .top-slides .inner-item .title {
    display: block;
    font-size: 2rem;
}
.barjestegi-container .result-container .top-slides .inner-item .desc {
    max-width: 150pt;
    margin: 5pt 0 0 auto;

    display: block;
    font-size: 1rem;
    /* color: hsla(0, 0%, 100%, 0.5); */
}
.barjestegi-container .result-container .top-slides .slide-card-back {
    height: 70%;

    position: absolute;
    bottom: 15%;
    right: 0;

    mix-blend-mode: luminosity;
    opacity: 0.3;
}
/* slide -> percent */
.barjestegi-container .result-container .top-slides .percent {
    width: 30%;
    text-align: center;

    position: absolute;
    top: 5%;
    left: 10%;

    display: flex;
    flex-direction: column;
}
.barjestegi-container .result-container .top-slides .percent .percent-shock {
    width: 100%;
}
.barjestegi-container .result-container .top-slides .percent .price {
    font-size: 1.5rem;
    font-family: Arial, Helvetica, sans-serif;
}
@media (max-width: 576px) {
    /* discount */
    .barjestegi-container .result-container .top-slides .percent {
        width: 40%;
        left: 15%;
    }
    .barjestegi-container .result-container .top-slides .percent .price {
        font-size: 1.5rem;
    }

    /* text container */
    .barjestegi-container .result-container .top-slides .inner-item .text-container {
        right: 10pt;
        top: 37.5vh;
    }
    .barjestegi-container .result-container .top-slides .inner-item .title {
        font-size: 1.4rem;
    }
    .barjestegi-container .result-container .top-slides .inner-item .desc {
        font-size: .9rem;
    }

    /* carousel */
    .barjestegi-container .result-container .top-slides .slides-carousel {
        width: calc(100% - 120pt);
        min-width: 145pt;
        margin-left: -100vw;
    }
}

/* ---------------------------------------- */
/* -------------- ITEMS LIST -------------- */
/* ---------------------------------------- */
.barjestegi-container .content-container .result-container .list-container {
    width: 100%;
    overflow: scroll;

    min-height: 25pt;
    margin: 20pt 0 10pt 0;
    background-color: #fff;
}
.barjestegi-container .content-container .result-container .item-list {
    width: max-content;
    padding: 0 10pt;
}
.barjestegi-container .content-container .item-list span {
    height: 100%;
    margin: auto 10pt;
    padding: 7pt 7pt;

    display: inline-block;
    vertical-align: sub;

    cursor: pointer;
    color: #86888e;
    border-top: 3px solid #fff;
}
.barjestegi-container .content-container .item-list span.active,
.barjestegi-container .content-container .item-list span:hover,
.barjestegi-container .content-container .item-list span:active {
    font-weight: bold;
    color: #373b48;
    border-top: 3px solid #ed412c;
}
@media (max-width: 576px) {
    .barjestegi-container .content-container .item-list span {
        margin: auto 5pt;
        font-size: calc(.8rem - 2pt);
    }
    .barjestegi-container .content-container .result-container .item-list {
        padding: 0 5pt;
    }
}

/* ---------------------------------------- */
/* ---------------- RESULT ---------------- */
/* ---------------------------------------- */
/* right nav */
.barjestegi-container .content-container .result-container .result {
    display: flex;
    flex-wrap: wrap;
}
.barjestegi-container .content-container .result-container .result .result-item {
    height: 100%;
    width: 40vw;
    margin: 10pt 5vw;
    padding: 0 5pt;

    text-align: center;
}
.barjestegi-container .result-container .result .result-item .top-item {
    height: calc(50% - 8pt);
    width: calc(100% - 10pt);
    margin-bottom: 8pt;
    padding: 30pt 5pt;

    display: flex;
    flex-direction: column;

    border-radius: 25pt;
    border: 3px solid #fff;
    box-shadow: 4px 6.9px 5px 0px #ccc;
    background-color: #ededed;
}
.barjestegi-container .content-container .result-container .result .result-item .circle {
    height: 4.5rem;
    width: 4.5rem;
    margin: auto auto 0;

    border: 5px solid #eeed;
    border-radius: 4.5rem;
    box-shadow: 0 3px 7px #bbb;
    background-color: #f8e07c;

    display: flex;
    flex-direction: column;
}
.barjestegi-container .content-container .result-container .result .result-item .circle img {
    height: 100%;
    width: 100%;
    margin: auto;
    border-radius: 100%;
}
.barjestegi-container .content-container .result-container .result .result-item .title,
.barjestegi-container .content-container .result-container .result .result-item .text {
    max-width: 140pt;
}
.barjestegi-container .content-container .result-container .result .result-item .title {
    display: inline-block;
    margin: 5pt auto;

    font-size: 1.4rem;
    font-weight: bold;
}
.barjestegi-container .content-container .result-container .result .result-item .text {
    display: inline-block;
    margin: 0 auto auto;

    font-size: 1rem;
    color: #373b48;
}
.barjestegi-container .content-container .result-items >>> .VueCarousel,
.barjestegi-container .content-container .result-items >>> .VueCarousel-wrapper,
.barjestegi-container .content-container .result-items >>> .VueCarousel-inner {
    height: 100% !important;
}
@media (max-width: 576px) {
    .barjestegi-container .content-container .result-container .result .result-item {
        width: 90vw;
    }
    .barjestegi-container .content-container .result-container .result .result-item .circle {
        height: 3rem;
        width: 3rem;
        border: 3px solid #eeed;
        border-radius: 3rem;
    }
    .barjestegi-container .content-container .result-container .result .result-item .circle i {
        font-size: 1.2rem;
    }
    .barjestegi-container .content-container .result-container .result .result-item .title {
        font-size: 1.1rem;
    }
    .barjestegi-container .content-container .result-container .result .result-item .text {
        font-size: .8rem;
    }
}
</style>
